module.exports = __webpack_public_path__ + "static/media/icon_maker_red_2.b9611a0b.svg";